// ═══════════════════════════════════════════════════════════════════════════
// ladoRol — ¿este rol es del lado Milbrands (app interna) o del lado cliente
// (portal)? UNA decisión, un solo lugar (caso DDA, 27-ago-2026).
// ═══════════════════════════════════════════════════════════════════════════
// El bug que esto arregla: la frontera vivía en una lista LITERAL de 4 roles
// (ROLES_STAFF_MILBRANDS) y todo rol creado después —"Analista de Producto y
// Calidad"— caía al portal de cliente aunque fuera staff. La fuente pasa a ser
// el CATÁLOGO: `roles/{codigo}.lado` ('milbrands' | 'cliente'), editable en
// /roles. La lista queda como FALLBACK para roles que aún no declararon lado
// — se retira cuando el censo de /roles dé todos declarados.
//
// Default fail-closed: sin doc, o con doc sin `lado` y fuera de la lista,
// el rol es CLIENTE — nadie entra a la app interna por omisión.
//
// ⚠️ `rolDoc` solo cuenta si es EL DOC DEL ROL EVALUADO (codigo === rolId):
// con "Ver como…" el rolDoc cargado sigue a la identidad simulada, y
// `isRealCliente` evalúa el rol REAL — cruzar doc de un rol con id de otro
// respondería sobre el rol equivocado.

export const LADO_MILBRANDS = 'milbrands'
export const LADO_CLIENTE = 'cliente'

// La lista legacy — mismo contenido que tenía AuthContext. NO agregar roles
// acá: los nuevos se declaran en /roles (campo Lado). allow-gating-literal
export const ROLES_STAFF_MILBRANDS = ['WIZARD', 'OPERACIONES', 'SUPERVISOR', 'CONSULTOR']

/** PURO. ¿El rol `rolId` es del lado Milbrands? */
export function esRolLadoMilbrands(rolId, rolDoc) {
  if (!rolId) return false
  const docAplica = rolDoc && (rolDoc.codigo || rolDoc.id) === rolId
  if (docAplica && rolDoc.lado) return rolDoc.lado === LADO_MILBRANDS
  return ROLES_STAFF_MILBRANDS.includes(rolId)
}
